import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Styles from "../../styles/preview/welcome.module.scss";
import Img_logo from "../../assets/auth/LOGO.svg";
import { adminRoutes } from "../../routers/AdminRouters";
import { getScheduleGym } from "../../services";

const getWeekNumber = (date) => {
  const d = new Date(
    Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
  );
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNo = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
  return weekNo;
};

const Welcome = () => {
  const { gymSchedule } = useSelector((state) => state.schedule);
  const [currentDate] = useState(new Date());
  const navigate = useNavigate();

  useEffect(() => {
    getScheduleGym();
  },[]);
   useEffect(() => {
      const timer = setTimeout(() => {
        navigate(adminRoutes.intro);
        
      }, 3000);
    
      return () => clearTimeout(timer);
    }, [navigate]);
  const todaySchedule = gymSchedule?.find((schedule) => {
    const scheduleDate = new Date(schedule.date);
    return scheduleDate.toDateString() === currentDate.toDateString();
  });

  const weekNumber = getWeekNumber(currentDate);

  const formattedDate = currentDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
  });

  return (
    <div className={Styles.welcome_container}>
      <div className={Styles.logo}>
        <div className={Styles.flexdivider_2_logo}>
          <img src={Img_logo} alt="admin_dash_logo" />
        </div>
      </div>

      <h1 className={Styles.title}>
        {todaySchedule ? todaySchedule.session.name : "No Session Today"}
      </h1>
      <div className={Styles.week_box}>
        <p className={Styles.week}>WEEK {weekNumber}</p>
        <p className={Styles.date}>{formattedDate}</p>
      </div>
    </div>
  );
};

export default Welcome;
